import { Citation } from "./citation"
import { CoordinatorService } from "./coordinator.service"
import { CSPAR } from "./template-repository$"
import { XItem } from "./x-item"

export class Citation$ {
    private _citationMap = new Map<string, Citation>()

    constructor(public coords: CoordinatorService) {
        this.coords.template$.repository$
            .citationStyleParams.forEach((x: CSPAR) => {
                const c = new Citation(this.coords, x)
                this._citationMap.set(c.id, c)
            })
    }

    get(tag: string) {
        return this._citationMap.get(tag)
    }

    cite(xitm: XItem, params?: any) {
        let c: Citation
        if (xitm.isPatent)
            c = this.get("patent")!
        else
            c = this.get("article_APA")!
        return c.cite(xitm, params)
    }

    docx(xitm: XItem, params?: any) {
        let c: Citation
        if (xitm.isPatent)
            c = this.get("patent")!
        else
            c = this.get("article_APA")!
        return c.docx(xitm, params)
    }
}
